import React, { Suspense } from "react";
import PropTypes from 'prop-types';
import { DashboardLayout, HeaderWrapper, OverlayDashboard } from '../CompanyDashBoardV2/styles';
const CompanyDetails = React.lazy(() => import("../CompanyDashBoardV2/CompanyDetails"))
import { HeaderWrapperV2 } from '../CompanyDashBoardV2/styles';
import { /*StyledTabs,*/ CompanyButton} from './styles';
// import { Tab } from "react-bootstrap";
const DailyTipContainer = React.lazy(() => import("../DailyTipAdmin/index"))
import {fetchTipCategoryCount, fetchDailyTipAndQuoteCount} from '../../redux/actions';
import {connect} from 'react-redux';
import Waiting from '../Waiting';
import isNull from 'lodash/isNull';
import isUndefined from 'lodash/isUndefined';
import moment from 'moment';
import {TabsStyle, TabsWrapper} from '../../components/common/commonStyles';
import { fetchApi } from "../../utils/methods";
import { GetSasLeads } from "../../redux/constants/apiConstants";
import { toast } from "react-toastify";
import CSVList from "../PeopleHomeV2/CSVList";

class AdminDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 1,
      companyId: props.companyInfo.id,
      year: moment().format('YYYY'),
      leadDetails: [],
      printLeadsCSV:false,
    }
  }


  getCSVHeaders = () => {

    const csvHeaders = [
      { label: "First name", key: "first_name" },
      { label: "Last Name", key: "last_name" },
      { label: "Mail", key: "work_email" },
      { label: "Company Name", key: "company_name" },
      { label: "Company Size", key: "company_size" },
      { label: "Goals", key: "goals" },
      { label: "Products", key: "products" },
      { label: "Created At", key: "created_at" },
    ];
    return csvHeaders;
  };

  componentDidMount(){
    const { fetchTipCategoryCount, fetchDailyTipAndQuoteCount} = this.props;
    const { companyId, year } = this.state;
    fetchTipCategoryCount();
    fetchDailyTipAndQuoteCount(companyId, year);
    this.getSasLeadDetails();
  }

  setActiveTab = (active) => {
    this.setState({ selectedTab: active })
  }

  printAction = (bool) => {
    this.setState({printLeadsCSV:bool});
  }

  getSasLeadDetails = async () => {    
    let apiUrl = GetSasLeads ;
    try {
      const res = await fetchApi(apiUrl , "GET");
      if (res?.status === "success") {
        const formattedData = res?.data?.map((item)=>({
          first_name: item.first_name || "",
          last_name: item.last_name || "",
          work_email: item.work_email || "",
          company_name: item.company_name || "",
          company_size: item.company_size || "",
          goals:Array.isArray(item.goals) ? item.goals.join(", ") : item.goals || "",
          products:Array.isArray(item.products) ? item.products.join(", ") : item.products || "",
          created_at: item.created_at ? moment(item.created_at).format("YYYY-MM-DD") : "",
        }));
        this.setState({ leadDetails: formattedData });
      } else {
        toast.error(res?.error);
      }
    } catch (error) {
      window.console.error(error);
    }
  };



  render() {
    const { role, companies, history , tipCategoryCount, tipQuoteCount} = this.props;
    const { selectedTab, printLeadsCSV} = this.state;
    if(isNull(tipCategoryCount)|| isUndefined(tipCategoryCount) || isNull(tipQuoteCount) || isUndefined(tipQuoteCount)) {
      return <Waiting />
    }
    return (
      <OverlayDashboard>
        <DashboardLayout>
          {role === "ADMIN" ? (
            <HeaderWrapperV2 padding={1} style={{marginTop:"20px"}}>
              {role === "ADMIN" &&
                <TabsWrapper style={{display:"flex",justifyContent:"space-between"}}>
                  <div style={{display:"flex"}}>
                    <TabsStyle  onClick={()=>this.setActiveTab(1)} active={selectedTab===1}>
                      Overview
                    </TabsStyle>
                    <TabsStyle  onClick={()=>this.setActiveTab(2)} active={selectedTab===2}>
                      Tips & Quotes
                    </TabsStyle>
                  </div>
                  <div style={{display:"flex"}}>
                    <CompanyButton onClick={()=> this.setState({printLeadsCSV:true})}>SaaS Leads</CompanyButton>
                    
                    <CompanyButton onClick={() => history.push('/company/edit_company')}>Edit Company</CompanyButton>
                    
                    <CompanyButton onClick={() => history.push('/company/create_company')}>Create Company</CompanyButton>
                    
                  </div>
                </TabsWrapper>}
              {
                selectedTab===1?<Suspense fallback={<Waiting/>}> <CompanyDetails history={history} role={role} companies={companies} /> </Suspense>:<Suspense fallback={<Waiting/>}><DailyTipContainer history={history} tipCategoryCount={tipCategoryCount} tipQuoteCount={tipQuoteCount}/></Suspense>
              }
            </HeaderWrapperV2>
          ) : (
            <HeaderWrapper />
          )}
        </DashboardLayout>
        {printLeadsCSV && <CSVList  Title={`${"SaaS Leads File"}`}   removeCSVData={this.printAction} headers={this.getCSVHeaders()} data={this.state.leadDetails  || []}   />}
      </OverlayDashboard>
    );
  }
}
AdminDashboard.propTypes = {
  networkError: PropTypes.string,
  companies: PropTypes.array,
  companyInfo: PropTypes.object.isRequired,
  setCompany: PropTypes.func.isRequired,
  role: PropTypes.string.isRequired,
  history: PropTypes.object,
  fetchTipCategoryCount: PropTypes.func,
  tipCategoryCount: PropTypes.array,
  fetchDailyTipAndQuoteCount: PropTypes.func,
  tipQuoteCount: PropTypes.array
};

const mapStateToProps = (state) => ({
  tipCategoryCount: state.companyDashboard.tipCategoryCount,
  tipQuoteCount:state.companyDashboard.tipQuoteCount
});

const mapDispatchToProps = (dispatch) => ({
  fetchTipCategoryCount: () => dispatch(fetchTipCategoryCount()),
  fetchDailyTipAndQuoteCount: (id, year) => dispatch(fetchDailyTipAndQuoteCount(id, year))
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminDashboard);
